import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProductAnalyticsService } from 'src/app/shared/services/product-analytics.service';
import { RenderHelpDialogComponent, RenderHelpOptions } from './help-dialog/render-help-dialog.component';
import { renderDialogPanes } from './render-home';

// Opens Help (render-help-dialog) from wherever it is asked for: the upload step's links (the
// zone, a refused drop, the texture checklist), the preview, the error page, the landing's FAQ.
// One at a time.
@Injectable()
export class RenderHelpService {
  private ref: MatDialogRef<RenderHelpDialogComponent> | null = null;

  constructor(private readonly dialog: MatDialog, private readonly productAnalytics: ProductAnalyticsService) {}

  public open(options: RenderHelpOptions = {}): void {
    if (this.ref) {
      return;
    }
    // Where Help was opened is the event's route; what it opened on, its params.
    this.productAnalytics.track('help_opened', {
      params: { tab: options.tab, app: options.app, step: options.step === undefined ? undefined : String(options.step), exporter: options.exporter?.app },
    });
    this.ref = this.dialog.open<RenderHelpDialogComponent, RenderHelpOptions>(RenderHelpDialogComponent, {
      data: options,
      autoFocus: 'dialog',
      ariaLabel: 'Help',
      panelClass: renderDialogPanes('render-help-pane'),
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '140ms',
    });
    this.ref.afterClosed().subscribe(() => (this.ref = null));
  }
}
